import React, { Component } from 'react'
import './property_information.scss'
import { compose } from "redux"
import { connect } from "react-redux"
import actions from "./actions/root_action"
import { withNamespaces } from "react-i18next"
import '../../i18n'
import Activity from './activity'

export class PropertyInformation extends Component {
  /**
   * スプレッドシート経由で取得したpropertyに関するホストのアンケートをJSONで返却する。
   *
   * @param  {string} propertyId 建物ID
   */
  surveyInfo(propertyId) {
    return this.props.lp.properties.find((property, index) => propertyId == (property.property_id - 0))
  }

  address(property) {
    if (!property) return
    return `${property.prefecture.ja}${property.city.ja}${property.street_address.ja}${property.apt_name.ja}`
  }

  parking(survey) {
    if (!survey) return

    if (survey.parking_type === 'free' && survey.free_parking_lots > 0) {
      return `無料駐車場あり：${survey.free_parking_lots}台`
    } else if (survey.parking_type === 'paid') {
      return "有料駐車場あり"
    }
  }

  render() {
    const propertyInfo = this.props.propertyInfo
    const survey = this.surveyInfo(this.props.propertyId)

    let { sanitizer } = survey
    let sanitizingOnCleaning = survey.sanitizing_on_cleaning
    let changingLinen = survey.changing_linen
    let comment = survey.comments

    return (
      <React.Fragment>
        <div styleName="property-info-wrapper">
          <h3 styleName="property-name">{this.props.propertyName}</h3>
          <div styleName="property-info">
            <div styleName="property-info-item">
              <span className="vs-icon-pin" styleName="pin-icon"></span>
              <span styleName="">{this.address(propertyInfo)}</span>
            </div>
            {
              this.parking(survey) &&
              <div styleName="property-info-item">
                <span className="vs-icon-parking" styleName="parking-icon"></span>
                <span styleName="">{this.parking(survey)}</span>
              </div>
            }
          </div>
          <div styleName="environment">
            <span styleName="around-environment">周辺環境</span>
            { survey.access_supermarket && <span styleName="super-market"><strong>スーパーマーケット</strong>：{survey.access_supermarket}</span> }
            { (survey.access_supermarket && survey.access_convenience_store) && <span styleName="divider">/</span> }
            { survey.access_convenience_store && <span styleName="convenience-store"><strong>コンビニ</strong>：{survey.access_convenience_store}</span> }
          </div>
          <div styleName="activities">
            { sanitizer && <Activity style="activity" size="small" label="消毒液" /> }
            { sanitizingOnCleaning && <Activity style="activity" size="small" label="清掃時に消毒実施" /> }
            { changingLinen && <Activity style="activity" size="small" label="清掃毎にリネン類交換" /> }
          </div>
          {comment &&
          <div styleName="comment-wrapper">
            <div styleName="comment">
              { comment }
            </div>
          </div>
          }
        </div>

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    search: state.search,
    lp: state.lp
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(PropertyInformation)
